import { render } from "./EspecialidadOptions.vue?vue&type=template&id=110dbd04"
import script from "./EspecialidadOptions.vue?vue&type=script&lang=js"
export * from "./EspecialidadOptions.vue?vue&type=script&lang=js"

import "../assets/general.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__